export enum UserRole {
    ADMIN = 'ADMIN',
    CLIENTE = 'CLIENTE',
    PROJETISTA = 'PROJETISTA',
    MONTADOR = 'MONTADOR',
    ATENDENTE = 'ATENDENTE'
}